import React, { useState, useEffect } from 'react';
import './About.css'; 
import AboutSubsection from './AboutSubsection';
import { motion, AnimatePresence} from 'framer-motion';
const BREAKPOINT = 768;

function About() {

  const getInitialShowMore = () => {
    const saved = localStorage.getItem('aboutShowMore');
    if (saved !== null) return JSON.parse(saved);
  
    // default based on screen size
    return window.innerWidth >= BREAKPOINT;
  };


  const [showMore, setShowMore] = useState(getInitialShowMore);
  const [isMobile, setIsMobile] = useState(false);

  const whoWeWorkWith = [ 'Founders & start-ups', 'SMEs & family-run businesses', 'Professionals & consultants', 'Growing companies preparing for scale' ]; 
  const howWeWork = [ 'Understand your business and challenges', 'Define scope, timelines, and outcomes', 'Execute with structured processes', 'Deliver insights, not just reports', 'Ongoing support as you grow' ]; 
  const whyDhreyAdvisors = [ 'Single point accountability', 'Strong technical depth with business perspective', 'Confidential, transparent, and responsive', 'Long-term partnership mindset' ];


  useEffect(() => {
    localStorage.setItem('aboutShowMore', JSON.stringify(showMore));
  }, [showMore]);

  
  useEffect(() => {
    // On first mount, detect mobile/desktop
    const mobile = window.innerWidth < BREAKPOINT;
    setIsMobile(mobile);
  
    // Only auto-open on desktop
    if (!mobile && localStorage.getItem('aboutShowMore') === null) {
      setShowMore(true);
    }
  }, []); 
  


  return(<section id="about" className="about">
    <div className="container">
      <div className="about-content">
        <div className="about-text">
          <h2 className="section-title">About Dhrey Advisors</h2>
  
          <p>
            Dhrey Advisors is a boutique advisory and compliance firm led by a team of Chartered Accountants and experienced professionals, bringing together over 10 years of combined experience across finance, taxation, audit, and regulatory advisory.
          </p>
  
          <p><strong>At Dhrey, advisory comes first.</strong></p>
  
          <p>
            We combine technical expertise with commercial understanding, ensuring our clients are not only compliant, but confident in their numbers and choices.
          </p>
  
          {/* 🔽 CONDITIONAL CONTENT */}
          <AnimatePresence initial={false}>
          {showMore && (
            <motion.div  key="about-drawer"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.9, ease: 'easeInOut' }}
            style={{ overflow: 'hidden' }}>
              <p>
                Every engagement is handled with senior-level involvement, clear accountability, and transparent communication.
              </p>
  
              <p>
                Dhrey Advisors exists to support businesses that want to build right — with confidence, control, and clarity.
              </p>
  
              <div className="about-sections">
                <AboutSubsection
                  title="Who We Work With"
                  items={whoWeWorkWith}
                  isNumbered
                />
  
                <AboutSubsection
                  title="How We Work"
                  items={howWeWork}
                  isNumbered
                />
  
                <AboutSubsection
                  title="Why Dhrey Advisors"
                  items={whyDhreyAdvisors}
                  isNumbered
                />
              </div>
            </motion.div>
          )}
          </AnimatePresence>
  
          {/* 🔗 TOGGLE LINK (MOBILE ONLY) */}
          {isMobile && (
            <button
              className="show-more-btn"
              onClick={() => setShowMore(prev => !prev)}
            >
              {showMore ? 'Show less' : 'Show more'}
            </button>
          )}
        </div>
      </div>
    </div>
  </section>
  );
}


export default About;
